import React from 'react';
import { Header } from './Header';
import { HeroSection } from './HeroSection';
import { UltimateCompetitionSection } from './UltimateCompetitionSection';
import { WatchSeason2Section } from './WatchSeason2Section';
import { CrewSection } from './CrewSection';
import { InTheNewsSection } from './InTheNewsSection';
import { PartnersSection } from './PartnersSection';
import { MoreBeastSection } from './MoreBeastSection';
import { TestimonialsSection } from './TestimonialsSection';
import { CookieConsent } from './CookieConsent';
export function BeastGamesLanding() {
  return <div className="min-h-screen bg-[#0f0f1a] text-white overflow-x-hidden selection:bg-[#ffd700] selection:text-black" data-id="element-1">
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <UltimateCompetitionSection data-id="element-5" />
        <WatchSeason2Section data-id="element-6" />
        <InTheNewsSection data-id="element-7" />
        <PartnersSection data-id="element-8" />
        <MoreBeastSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <CrewSection data-id="element-11" />
      </main>
      <CookieConsent data-id="element-12" />
    </div>;
}